import { create } from '@thoughtspot/logger';
import { getChartType } from '../../../../utils/common-util';
const logger = create('chart-to-ts > native-chart-events');
const HTTP_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};
const HTTP_METHODS = {
    POST: 'POST',
};
const MUZE_STUDIO_CODEGEN_API_PATH = '/muze-studio/codegen/query';
export const getMuzeStudioCodegenEventProcessor = (props) => {
    const { chartModel } = props;
    const chartType = getChartType(chartModel);
    return {
        validateEventPayload: (eventData) => {
            logger.info('validateEventPayload', { eventData, chartType });
            if (!eventData?.payload?.body) {
                return {
                    isValid: false,
                    errors: ['eventData.payload.body is required in payload'],
                };
            }
            try {
                JSON.parse(eventData.payload.body);
            }
            catch (error) {
                return {
                    isValid: false,
                    errors: ['Payload body must be valid JSON'],
                };
            }
            return { isValid: true };
        },
        executeEvent: async (eventData) => {
            try {
                const response = await fetch(`${window.location.origin}${MUZE_STUDIO_CODEGEN_API_PATH}`, {
                    method: HTTP_METHODS.POST,
                    headers: HTTP_HEADERS,
                    credentials: 'include',
                    body: eventData.payload.body,
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return {
                    isValid: true,
                    data: await response.json(),
                };
            }
            catch (error) {
                logger.warn('Error fetching data:', error);
                return {
                    isValid: false,
                    errors: [
                        error instanceof Error
                            ? error.message
                            : 'Unknown error occurred',
                    ],
                };
            }
        },
    };
};
//# sourceMappingURL=index.js.map